import React from 'react';
import { BriefFitProvider } from '../PartnershipBrief/BriefPage';
import { DocPagingProvider } from '../../contexts/DocPagingContext';
import { useFinancialModel } from '../../hooks/useFinancialModel';
import { ModelSheet } from './ModelSheet';

/** The one-page Financial Model, styled to pair with either two-pager. */
export function FinancialModel() {
  const model = useFinancialModel();
  return <BriefFitProvider data-id="element-476" data-mp="3g9duivao16rh">
      <DocPagingProvider offset={0} total={1} data-id="element-477" data-mp="3ga703sxw1q81">
        <ModelSheet model={model} data-id="element-478" data-mp="3kah6v7ti8kny" />
      </DocPagingProvider>
    </BriefFitProvider>;
}